import { onBeforeMount, reactive, ref } from "@vue/composition-api";
import router from "@/router";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import customerDetailModel from "@/models/data-management/customer-detail";
import store from "@/store";

export default function useProfileCard(queryDataId, queryDataKey) {
  const {
    openValidationModal,
    closeValidationModal,
    openWarningModal,
    openSuccessModal,
    openDefaultErrorModal,
  } = useValidationModal();

  const isLoading = ref(false);
  const noItem = ref(false);

  const profileDetail = reactive({
    name: null,
    imageUrl: null,
    details: {
      mobile: null,
      // lineId: null,
      email: null,
      birthDate: null,
      // consent: null,
    },
  });

  const modalType = reactive({
    customer: false,
  });

  const isVerified = ref(false);


  const { fetchQueryDataDetailModel } = customerDetailModel();

  const { openModal, closeModal } = useModal();

  const openDeleteWarningModal = () => {
    const title = "คุณต้องการลบข้อมูลของคุณ";
    const description = "แน่ใจแล้วใช่ไหม ?";

    openWarningModal(title, description, () =>
      openSuccessModal(
        "ทำรายการสำเร็จ !",
        null,
        null,
        () => router.push("/data-management/list/Customer_List"),
        () => router.push("/data-management/list/Customer_List")
      )
    );
  };

  const openCustomerEditModal = () => {
    modalType.customer = true;
    openModal();
  };

  const closeCustomerEditModal = () => {
    closeModal();
    modalType.customer = false;
  };

  const confirmViewData = () => {
    if (isVerified.value == false) {
      openWarningModal("ยันยืนการดูข้อมูล", `ต้องการยืนยันใช่หรือไม่ ?`, () => {
        isVerified.value = true;
        fetchQueryDataDetail();
      });
    } else {
      openWarningModal(
        "ยันยืนการซ่อนข้อมูล",
        `ต้องการยืนยันใช่หรือไม่ ?`,
        () => {
          isVerified.value = false;
          fetchQueryDataDetail();
        }
      );
    }
  };

  const fetchQueryDataDetail = () => {
    isLoading.value = true;
    fetchQueryDataDetailModel.payload.QueryDataId = queryDataId;
    fetchQueryDataDetailModel.payload.QueryData_Key = queryDataKey;
    fetchQueryDataDetailModel.payload.Payloads = [
      { Key: "customerid", Value: router.currentRoute.query.customerid },
    ];
    fetchQueryDataDetailModel.payload.IsVerified = isVerified.value;

    store
      .dispatch("api/apiRequest", fetchQueryDataDetailModel)
      .then((response) => {
        response.data.payload.map((o) => {
          initProfileDetail(o);
        });
        isLoading.value = false;
      })
      .catch((err) => {
        openDefaultErrorModal(err);
        isLoading.value = false;
        noItem.value = true;
      });
  };

  const initProfileDetail = (profileData) => {
    profileDetail.name =
      profileData.first_name_th + " " + profileData.last_name_th;
    profileDetail.imageUrl = profileData.image;
    profileDetail.details.mobile = profileData.mobileno || "-";
    // profileDetail.details.lineId = profileData.uid_line;
    profileDetail.details.email = profileData.email || "-";
    if (profileData.dateofbirth) {
      profileDetail.details.birthDate =
        resolveDate(profileData.dateofbirth)
    } else {
      profileDetail.details.birthDate = '-'
    }

    // profileDetail.details.consent = profileData.pdpa
    //   ? 'Consented'
    //   : 'Not Consented';
  };

  const resolveDate = (date) => {
    const dateObject = new Date(date);

    return `${dateObject.getDate()} ${dateObject.toLocaleString("default", {
      month: "long",
    })} ${dateObject.getFullYear()}`;
  };

  onBeforeMount(() => {
    fetchQueryDataDetail();
  });

  return {
    profileDetail,
    isLoading,
    noItem,
    openValidationModal,
    closeValidationModal,
    openWarningModal,
    openDeleteWarningModal,
    openCustomerEditModal,
    closeCustomerEditModal,
    modalType,
    confirmViewData,
    isVerified
  };
}
